import { isLocalUrl } from '../utils.js';

export default function () {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
    </div>
    <div class="swiper-container swiper-container-content">
      <div class="swiper-button-prev"></div>
     <div class="swiper-wrapper"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
    </div>      
  `;

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {
    const textTitle = slide.Title;
    const cropTitle = textTitle.length > 50 ? textTitle.substring(0, 70) + '...' : textTitle;
    const title = `<h2 title="${textTitle}">${cropTitle}</h2>`;

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn1) {
          const isLocalURL = isLocalUrl(btn1);
          btnContainer.append(
            `<a href="${btn1}"${isLocalURL ? '' : ' target="_blank"'} class="button">${btn1Text}</a>`,
          );
        }
        if (btn2) {
          const isLocalURL = isLocalUrl(btn2);
          btnContainer.append(
            `<a href="${btn2}"${isLocalURL ? '' : ' target="_blank"'} class="button">${btn2Text}</a>`,
          );
        }

        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          ${title}
          ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    widgetData.forEach(function (slide) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true,
      },
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
